import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-de1dc5fc"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    key: 0,
    class: "crm-container"
};
const _hoisted_2 = { class: "bg-slate-50 h-screen md:grid md:grid-cols-12 md:grid-rows-1 w-screen overflow-y-auto" };
const _hoisted_3 = { class: "md:col-span-10 md:overflow-y-auto pb-10" };
import { RouterView, useRouter } from "vue-router";
import ConfirmPasswordModal from "@/components/ConfirmPasswordModal.vue";
import { useAuthentication } from "@/stores/authentication";
import Sidebar from "@/components/Sidebar.vue";
import Header from "@/components/Header.vue";
import { isStatusError } from "@/meta";
import { flare } from '@flareapp/flare-client';
import { storeToRefs } from "pinia";
import { useFetch } from "@/helpers";
export default /*#__PURE__*/ _defineComponent({
    setup(__props) {
        const router = useRouter();
        const { fetchCurrentUser } = useAuthentication();
        const { currentUser } = storeToRefs(useAuthentication());
        const { loading, fetch } = useFetch(async () => {
            try {
                await fetchCurrentUser();
                flare.addContextGroup("user", currentUser?.value || {});
            }
            catch (err) {
                if (isStatusError(err) && err.statusCode === 401) {
                    router.push("/login");
                }
            }
        });
        fetch();
        return (_ctx, _cache) => {
            return (!_unref(loading) && _unref(currentUser))
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(ConfirmPasswordModal, null, {
                        default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_2, [
                                _createVNode(Sidebar, { class: "md:col-span-2" }),
                                _createElementVNode("main", _hoisted_3, [
                                    _createVNode(Header),
                                    _createVNode(_unref(RouterView), { class: "col-span-10" }, {
                                        default: _withCtx(({ Component }) => [
                                            (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
                                        ]),
                                        _: 1
                                    })
                                ])
                            ])
                        ]),
                        _: 1
                    })
                ]))
                : _createCommentVNode("", true);
        };
    }
});
